module.exports = {
      id: "video-usage",
      viewBox: "0 0 21.4 21.4",
      url: __webpack_public_path__ + "img/icons.a7e6c507.svg#video-usage",
      toString: function () {
        return this.url;
      }
    }